import React from 'react'
import { Draggable } from 'react-beautiful-dnd'
import { Field } from 'formik'
import { IconMenu2, IconInfoCircle, IconTrash } from '@tabler/icons-react'

import { Button } from '@/components/buttons/Button'
import { InteractiveTooltip } from '@/components/tooltips/InteractiveTooltip'
import { Checkbox, TextField } from '@/components/forms/formik'

import './editSectionsForm.css'

export const EditMeasuresRow = ({
  newItem,
  index,
  remove,
  shouldFocus,
  errors,
  updateStatusInObject,
  updateNameInObject,
  removeObject,
}) => {
  const currentMeasure = newItem

  return (
    <Draggable
      key={currentMeasure.id.toString()}
      draggableId={currentMeasure.id.toString()}
      index={index}
    >
      {(provided) => {
        return (
          <div
            {...provided.draggableProps}
            {...provided.dragHandleProps}
            ref={provided.innerRef}
            className="edit-scorecard-form__row"
          >
            <div className="edit-scorecard-form__drag-handle">
              <IconMenu2 size={16} />
            </div>
            <div className="edit-scorecard-form__name">
              <Field
                name={`measures.${index}.name`}
                data-testid={`measures.${index}.name`}
                disabled={!currentMeasure.active}
                component={TextField}
                type="text"
                max="100"
                placeholder="New Measure"
                autoFocus={shouldFocus}
                errorMessage={errors?.measures && errors.measures[index]?.name}
                onChange={(event) => updateNameInObject(event, currentMeasure)}
              />
            </div>
            <InteractiveTooltip
              content={
                <div>
                  {currentMeasure?.criteria?.length > 0
                    ? `${currentMeasure.criteria.length} Criteria in Use`
                    : 'No Criteria In Use'}
                </div>
              }
            >
              <IconInfoCircle className="icon-svg" />
            </InteractiveTooltip>
            <Field name={`measures.${index}.active`} label={null}>
              {(formikProps) => (
                <Checkbox
                  toggle
                  data-testid="measure-active-toggle"
                  {...formikProps}
                  onClick={() => updateStatusInObject(newItem, index)}
                />
              )}
            </Field>
            <Button
              critical
              square
              data-testid="basic-modal-delete-button"
              onClick={() => {
                remove(index)
                removeObject(newItem, currentMeasure)
              }}
            >
              <IconTrash />
            </Button>
          </div>
        )
      }}
    </Draggable>
  )
}
